"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var preact_1 = require("preact");
var HeroSaleSticker = function (_a) {
    var stickerUrl = _a.stickerUrl, theme = _a.theme;
    return ((0, preact_1.h)("img", { class: "sale-sticker sale-sticker--".concat(theme, " sale-sticker--email"), src: stickerUrl, alt: "now on sale!" }));
};
exports.default = HeroSaleSticker;
